'use client'
import { tw } from 'utils/classnames'

import { CopyAllIcon } from '@web/components/icons/copy-all'
import { Button } from './button'

interface InputLinkProps {
  link: string
  buttonLabel: string
  copiedLabel: string
  className?: string
  onCopied?: () => void
}

export function UrlShare({ link, className, buttonLabel, copiedLabel, onCopied }: InputLinkProps) {
  return (
    <label
      className={tw(
        'bg-cf-dreamy-cloud-200 rounded-2 flex w-full max-w-5xl border border-[#DFDDE5]',
        className,
      )}
    >
      <input
        disabled
        className="text-14 text-cf-dreamy-cloud-900 w-full grow p-2"
        type="text"
        value={link}
      />
      <Button
        icon={<CopyAllIcon />}
        text={buttonLabel}
        textToCopy={link}
        copiedLabel={copiedLabel}
        onClick={onCopied}
        showCheckWhenCopied
        className="whitespace-nowrap"
      />
    </label>
  )
}
